import InitApi from "api/InitApi";
import { useMutation, useQueryClient } from "react-query";
import useTokenStore from "store/tokenStore";

const useSetSpotlightedBooks = () => {
	const { accessToken } = useTokenStore();
	const queryClient = useQueryClient();

	const mutate = async ({ bookId, action = 'toggle' }) => {
		const instance = await InitApi({ accessToken });
		const res = await instance.patch(`books/spotlight/${bookId}`, { action });
		return res.data;
	};

	return useMutation(mutate, {
		onSuccess: () => {
			queryClient.invalidateQueries(["spotlighted-books"]);
			queryClient.invalidateQueries(["books"]);
		},
	});
};

export default useSetSpotlightedBooks;
